import React, { Component } from 'react';

import { connect } from "react-redux";

class ReportViewer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selReportName: props.reportName
        };
    }

    componentDidMount() {
        this.initTelerikReportViewer();
    }

    async componentWillReceiveProps(nextProps) {
        if (this.props.isModalWindow === "false") {
            if (this.props !== nextProps) {
                await this.setState({
                    selReportName: nextProps.reportName
                });
            }
            var reportViewer = window.$(this.refs.reportViewer1).data("telerik_ReportViewer");
            //this.initTelerikReportViewer();
            reportViewer.reportSource({
                report: this.getReportName(),

                parameters: this.props.rptParameters
            });
        }
    }

    getReportName() {
        return `ReportLibrary.${this.state.selReportName}, AxisWWSC`;
    }

    getServiceUrl() {
        return `${window.location.protocol}//${window.location.host}/api/reports/`;
    }

    ReportViewerParams() {
        if (this.props.isModalWindow === "true") {
            return {
                parameterEditors: [{}],

                // The URL of the service which will serve reports.
                // The URL corresponds to the name of the controller class (ReportsController).
                // For more information on how to configure the service please check http://www.telerik.com/help/reporting/telerik-reporting-rest-conception.html.
                serviceUrl: this.getServiceUrl(), //"http://localhost:57614/api/reports/",
                //serviceUrl: "https://reportapis-prod.azurewebsites.net/api/reports/",
                //serviceUrl:"https://reportapis-prod-staging.azurewebsites.net/api/reports/",
                //serviceUrl:"https://reportapis-prod-development.azurewebsites.net/api/reports/",
                // The URL for the report viewer template. The template can be edited -
                // new functionalities can be added and unneeded ones can be removed.
                // For more information please check http://www.telerik.com/help/reporting/html5-report-viewer-templates.html.
                // templateUrl: 'ReportViewer/templates/telerikReportViewerTemplate.html',

                //ReportSource - report description

                reportSource: {

                    // The report can be set to a report file name (.trdx or .trdp report definition)
                    // or CLR type name (report class definition).

                    report: this.getReportName(),//"ReportLibrary." + this.state.selReportName + ", ReportLibrary",

                    // Parameters name value dictionary
                    parameters: this.props.rptParameters

                },

                // Specifies whether the viewer is in interactive or print preview mode.
                // PRINT_PREVIEW - Displays the paginated report as if it is printed on paper. Interactivity is not enabled.
                // INTERACTIVE - Displays the report in its original width and height without paging. Additionally interactivity is enabled.
                viewMode: window.telerikReportViewer.ViewModes.INTERACTIVE,

                // Sets the scale mode of the viewer.
                // Three modes exist currently:
                // FIT_PAGE - The whole report will fit on the page (will zoom in or out), regardless of its width and height.
                // FIT_PAGE_WIDTH - The report will be zoomed in or out so that the width of the screen and the width of the report match.
                // SPECIFIC - Uses the scale to zoom in and out the report.
                scaleMode: window.telerikReportViewer.ScaleModes.SPECIFIC,

                // Zoom in and out the report using the scale
                // 1.0 is equal to 100%, i.e. the original size of the report
                scale: 1.0,

                //Enables or disables the accessibility features of the report viewer and its contents.
                enableAccessibility: false,

                // Hides parameters area and disables the toggle
                parametersAreaVisible: false,

                //If set to true shows the Send Mail Message toolbar button
                //sendEmail: { enabled: true, from: "axiswwsc1@gmail.com" }
                sendEmail: { enabled: true, from: "noreply@axiswwsc.com" }

            };
        }
        else {
            return {
                //parameterEditors: [{
                //    match: function (parameter) {
                //        return Boolean(parameter.availableValues);
                //    },

                //    createEditor: function (placeholder, options) {
                //        var dropDownElement = window.$(placeholder).html('<div></div>'),
                //            parameter,
                //            valueChangedCallback = options.parameterChanged,
                //            dropDownList;

                //        function onChange() {
                //            var val = dropDownList.value();
                //            valueChangedCallback(parameter, val);
                //        }

                //        return {
                //            beginEdit: function (param) {

                //                parameter = param;

                //                window.$(dropDownElement).kendoMultiSelect({
                //                    dataTextField: "name",
                //                    dataValueField: "value",
                //                    value: parameter.value,
                //                    dataSource: parameter.availableValues,
                //                    change: onChange
                //                });

                //                dropDownList = window.$(dropDownElement).data("kendoMultiSelect");

                //                //if (!parameter.multivalue) {
                //                //    window.$(dropDownElement).kendoDropDownList({
                //                //        dataTextField: "name",
                //                //        dataValueField: "value",
                //                //        value: parameter.value,
                //                //        dataSource: parameter.availableValues,
                //                //        change: onChange
                //                //    });

                //                //    dropDownList = window.$(dropDownElement).data("kendoDropDownList");
                //                //}
                //                //else {
                //                //    window.$(dropDownElement).kendoMultiSelect({
                //                //        dataTextField: "name",
                //                //        dataValueField: "value",
                //                //        value: parameter.value,
                //                //        dataSource: parameter.availableValues,
                //                //        change: onChange
                //                //    });

                //                //    dropDownList = window.$(dropDownElement).data("kendoMultiSelect");
                //                //}
                //            }
                //        };
                //    }

                //}], 

                // The URL of the service which will serve reports.
                // The URL corresponds to the name of the controller class (ReportsController).
                // For more information on how to configure the service please check http://www.telerik.com/help/reporting/telerik-reporting-rest-conception.html.
                //serviceUrl: "http://localhost:57614/api/reports/",                 
                serviceUrl: this.getServiceUrl(),
                //serviceUrl: "https://reportapis-prod-development.azurewebsites.net/api/reports/",
                //###########################################################################
                //serviceUrl: "https://reportapis-prod.azurewebsites.net/api/reports/",
                //serviceUrl: "https://reportapis-prod-staging.azurewebsites.net/api/reports/",
                // The URL for the report viewer template. The template can be edited -
                // new functionalities can be added and unneeded ones can be removed.
                // For more information please check http://www.telerik.com/help/reporting/html5-report-viewer-templates.html.
                // templateUrl: 'ReportViewer/templates/telerikReportViewerTemplate.html',

                //ReportSource - report description
                reportSource: {

                    // The report can be set to a report file name (.trdx or .trdp report definition)
                    // or CLR type name (report class definition).
                    report: this.getReportName(),//"ReportLibrary." + this.state.selReportName + ", ReportLibrary",

                    // Parameters name value dictionary
                    parameters: this.props.rptParameters

                },

                parameters: {
                    editors: {
                        singleSelect: window.telerikReportViewer.ParameterEditorTypes.COMBO_BOX,
                        multiSelect: window.telerikReportViewer.ParameterEditorTypes.COMBO_BOX
                    }
                },
                // Specifies whether the viewer is in interactive or print preview mode.
                // PRINT_PREVIEW - Displays the paginated report as if it is printed on paper. Interactivity is not enabled.
                // INTERACTIVE - Displays the report in its original width and height without paging. Additionally interactivity is enabled.
                viewMode: window.telerikReportViewer.ViewModes.INTERACTIVE,

                // Sets the scale mode of the viewer.
                // Three modes exist currently:
                // FIT_PAGE - The whole report will fit on the page (will zoom in or out), regardless of its width and height.
                // FIT_PAGE_WIDTH - The report will be zoomed in or out so that the width of the screen and the width of the report match.
                // SPECIFIC - Uses the scale to zoom in and out the report.
                scaleMode: window.telerikReportViewer.ScaleModes.SPECIFIC,

                // Zoom in and out the report using the scale
                // 1.0 is equal to 100%, i.e. the original size of the report
                scale: 1.0,

                //Enables or disables the accessibility features of the report viewer and its contents.
                enableAccessibility: false,

                //If set to true shows the Send Mail Message toolbar button
                sendEmail: { enabled: true, from: "noreply@axiswwsc.com" }
            };
        }
    }
    initTelerikReportViewer() {
        window.$(this.refs.reportViewer1)
            .telerik_ReportViewer(
                this.ReportViewerParams()
            );
    }

    render() {
        const isModal = this.props.isModalWindow === "true" ? true : false;
        if (isModal) {
            return (
                <div ref="reportViewer1" id="reportViewer1" style={{ height: 700 }} > is loading ...</div>
            );
        }
        else {
            return (
                <div ref="reportViewer1" id="reportViewer1"> is loading ...</div>
            );
        }
    }
}

ReportViewer.propTypes = {};
ReportViewer.defaultProps = {};
const
    mapStateToProps = state => ({
        user: state.userAuthentication.user
    });
export default connect(mapStateToProps, null)(ReportViewer);